import { Routes } from '@angular/router';
import { adminGuard } from '@tsin-core/guards/admin.guard';
import { authGuard } from '@tsin-core/guards/auth.guard';
import { facilitatorGuard } from '@tsin-core/guards/facilitator.guard';
import { universityGuard } from '@tsin-core/guards/university.guard';
import { SsoCallbackComponent } from './pages/account/sso-callback/sso-callback.component';

export const routes: Routes = [
  { path: '', redirectTo: '/account/validate-token', pathMatch: 'full' },
  { path: 'user', canActivate: [authGuard], loadChildren: () => import('./pages/user/user.routes') },
  { path: 'facilitator', canActivate: [authGuard, facilitatorGuard], data: { preload: true }, loadChildren: () => import('./pages/facilitator/facilitator.routes') },
  { path: 'university', canActivate: [authGuard, universityGuard], data: { preload: true }, loadChildren: () => import('./pages/university/university.routes') },
  { path: 'management', canActivate: [authGuard, adminGuard], data: { preload: true }, loadChildren: () => import('./pages/management/management.routes') },
  { path: 'account', data: { preload: true }, loadChildren: () => import('./pages/account/account.routes') },
  { path: 'sign-up', data: { preload: true }, loadChildren: () => import('./pages/sign-up/sign-up.routes') },
  /**
   * SSO callback — auth-ui redirects here after Cognito login.
   * Reads the id_token cookie and exchanges it for a learning JWT.
   * The /fr prefix variant ensures French users stay in their locale.
   *
   * Callback SSO — auth-ui redirige ici après la connexion Cognito.
   * Lit le cookie id_token et l'échange contre un jeton JWT d'apprentissage.
   * Le préfixe /fr garantit que les francophones restent dans leur locale.
   */
  { path: 'auth/callback', component: SsoCallbackComponent },
  { path: 'fr/auth/callback', component: SsoCallbackComponent },
  { path: '**', redirectTo: '/account/validate-token' }
];
